var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{'has-error':_vm.validateError},staticStyle:{"font-size":"0"}},[_c('label',{staticClass:"control-label form-group-label",class:{
        'text-right':_vm.isHorizontal,
        'text-left':!_vm.isHorizontal
      },style:({
        'width':_vm.isHorizontal?_vm.labelWidth+'%':'auto'
      }),attrs:{"for":_vm.name}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),_c('div',{class:{
    'control-block':_vm.isHorizontal
  },style:({
    'width':(_vm.isHorizontal?(100-_vm.labelWidth):100)+'%'
  })},[_c('p',{attrs:{"data-a":_vm.isHorizontal}},[_vm._t("default")],2),_vm._v(" "),_c('transition',{attrs:{"name":"errorinfo"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.validateError),expression:"validateError"}],staticClass:"help-block"},[_vm._v(_vm._s(_vm.errorMessage))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f1d7a38","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ht/form/MaFormGroup.vue
// module id = 245
// module chunks = 0